import { Col as Cols } from 'react-awesome-styled-grid';
import styled from 'styled-components';

export const Col = styled(Cols)``;
